import { render, staticRenderFns } from "./ReportTotals.vue?vue&type=template&id=30cfb12e&"
import script from "./ReportTotals.vue?vue&type=script&lang=js&"
export * from "./ReportTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30cfb12e')) {
      api.createRecord('30cfb12e', component.options)
    } else {
      api.reload('30cfb12e', component.options)
    }
    module.hot.accept("./ReportTotals.vue?vue&type=template&id=30cfb12e&", function () {
      api.rerender('30cfb12e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/reports/ReportTotals.vue"
export default component.exports